import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAdminAuth } from "./AdminAuthContext";
import Logo from "../components/Logo";

const NAV = [
    { to: "/admin", label: "Overview", end: true },
    { to: "/admin/costs", label: "Costs" },
    { to: "/admin/users", label: "Users" },
    { to: "/admin/markets", label: "Markets" },
    { to: "/admin/funnel", label: "Funnel" },
    { to: "/admin/referrals", label: "Referrals" },
    { to: "/admin/archetypes", label: "Archetypes" },
    { to: "/admin/pricing", label: "Pricing" },
    { to: "/admin/access-codes", label: "Access codes" },
    { to: "/admin/feedback", label: "Feedback" },
];

export default function AdminLayout() {
    const { admin, logout } = useAdminAuth();
    const nav = useNavigate();

    const onLogout = async () => {
        await logout();
        nav("/admin");
    };

    return (
        <div className="min-h-screen bg-cream text-ink flex" data-testid="admin-layout">
            {/* Sidebar */}
            <aside className="w-60 shrink-0 border-r border-burgundy/15 bg-cream-soft min-h-screen flex flex-col">
                <div className="px-5 pt-6 pb-8 flex items-center gap-3">
                    <Logo size={42} />
                    <div>
                        <div className="font-display italic text-burgundy text-xl leading-tight">Ever After</div>
                        <div className="text-[9px] tracking-[0.3em] uppercase text-ink-muted">Operator</div>
                    </div>
                </div>

                <nav className="flex-1 flex flex-col gap-1 px-3">
                    {NAV.map(item => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            end={item.end}
                            data-testid={`nav-${item.label.toLowerCase()}`}
                            className={({ isActive }) =>
                                `px-4 py-2.5 text-sm tracking-wide transition-colors ${
                                    isActive
                                        ? "bg-burgundy text-cream"
                                        : "text-ink hover:bg-burgundy/[0.05]"
                                }`
                            }
                        >
                            {item.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="px-5 py-5 border-t border-burgundy/15">
                    <div className="text-[10px] tracking-[0.28em] uppercase text-ink-muted">Signed in</div>
                    <div className="text-sm text-burgundy font-medium truncate">{admin?.email}</div>
                    <button
                        data-testid="admin-logout-btn"
                        onClick={onLogout}
                        className="mt-3 text-[10px] tracking-[0.28em] uppercase text-burgundy underline-offset-4 hover:underline"
                    >
                        Sign out
                    </button>
                </div>
            </aside>

            {/* Main */}
            <main className="flex-1 min-h-screen overflow-x-hidden">
                <Outlet />
            </main>
        </div>
    );
}
